// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import shallowEqual from 'shallowequal';
import { isEqual } from 'lodash';
import { createSelector } from 'reselect';

// Components
import Column from './Column';

// Selectors
import { getElementChildIdsSorted } from '../selectors/elementChildrenSelector';
import { makeContainerElementChildrenTypesSelector } from '../containerElement/containerElementSelector';

const makeColumnSelector = () =>
    createSelector(
        getElementChildIdsSorted(),
        makeContainerElementChildrenTypesSelector(),
        (childElementIds, childrenTypes) => ({
            childElementIds,
            childrenTypes,
        }),
    );

@connect(makeColumnSelector)
class ColumnContainer extends React.Component {
    shouldComponentUpdate(nextProps) {
        // Check for shallow equality on everything except for ancestorIds.
        return !shallowEqual(this.props, nextProps, (thisValue, nextValue, key) => {
            if (key !== 'childElementIds') return;
            return thisValue === nextValue || isEqual(thisValue, nextValue);
        });
    }

    render() {
        return <Column {...this.props} />;
    }
}

ColumnContainer.propTypes = {
    element: PropTypes.object.isRequired,
    children: PropTypes.array,
    currentBoardId: PropTypes.string,
    connectDropTarget: PropTypes.func,
    isHovered: PropTypes.bool,
    isPresentational: PropTypes.bool,
};

export default ColumnContainer;
